import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import { useImqBrokerEmploymentDetailsPageStore } from 'store/pages/quote/imq-add-employees/employment-details/pageStore';

export const PageContent: React.FC = observer(() => {
  const {
    getFlowAndPageInitialData,
    isInitialLoading,
    flowDelegate,
    domainParams,
    dynamicFormDelegate,
    isStepCompleted,
    returnBack,
  } = useImqBrokerEmploymentDetailsPageStore();

  useEffect(() => {
    void getFlowAndPageInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ ...domainParams }}
      pageId={QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_EMPLOYMENT_DETAILS}
      isInitialLoading={isInitialLoading}
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
      moreInfoBlob={
        flowDelegate.groupInfoDelegate.moreInfoBlobInput
          ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
          : undefined
      }
      pageFooter={null}
    >
      <DynamicForm
        formDelegate={dynamicFormDelegate}
        onBack={returnBack}
        completeButtonText={isStepCompleted ? 'Update' : 'Complete'}
      />
    </PageInFlowNoSidebarLayout>
  );
});
